import { observer } from "mobx-react-lite";
import { Layer, Source } from "react-map-gl";
import { useAuthStore, useMapStore } from "../..";
import ILayerProps from "../../interfaces/IlayerProps";
import { minZoom } from "../mapConfig";

function ParcelsMapLayer({ visible }: ILayerProps) {
    const authStore = useAuthStore();
    const mapStore = useMapStore();
    if (!mapStore.isStyleLoaded)
        return null;

    return (
        <Source id="parcels" type="vector" tiles={[
            `https://tiles.regrid.com/api/v1/parcels/{z}/{x}/{y}.mvt?token=${authStore.publicRegridAccessToken}`,
        ]} minzoom={minZoom.parcels}>
            <Layer
                id="parcelsLayer"
                type="line"
                source-layer="parcels"
                minzoom={minZoom.parcels}
                paint={{
                    "line-width": 3,
                    'line-color': "#FAD3AC",
                }}
                layout={{
                    "visibility": visible ? "visible" : "none",
                }}
            />
        </Source>
    );
}

export default observer(ParcelsMapLayer);